<!-- people -->
<template>
  <div class="content has_breadcrumb">
    <base-breadcrumb
      :data="[
        {
          routeName: 'locations',
          name: schoolName
        },
        {
          name: 'People'
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage pageType="2" title="People">
      <template v-slot:left>
        <gg-flex-menus :menus="menuDatas" @select="menuSelect" :default-active="activeIndex" />
      </template>
      <template v-if="dataType === 'schoolName'">
        <GgPageHeader :title="schoolName" />
        <border-less-table :data="personalInfoData" />
      </template>
      <edoovo-table
        v-if="dataType === 'teachers'"
        height="100%"
        :ref="teachersData.ref"
        :data="teachersData.tableData"
        rowKey="id"
        :title="teachersData.title"
        defaultValue="-"
        class="list-tableBox"
        v-loading="teachersData.isLoading"
        @sortChange="_onSortChangeTeachers"
        :sort="teachersData.sort"
      >
        <!-- ===== -->
        <!-- 空状态 -->
        <!-- ===== -->
        <div slot="empty" style="text-align: center">
          <div
            style="
              width: 213px;
              text-align: center;
              border-radius: 50%;
              margin-bottom: 12px;
              line-height: 200px;
            "
          >
            <img style="width: 100%" :src="require('@/assets/images/products/noData.svg')" />
          </div>
          <p style="font-size: 22px">No Teachers yet.</p>
        </div>
        <!-- ====== -->
        <!-- 筛选组件 -->
        <!-- ====== -->
        <div v-if="filterRenderDataTeachers.length" class="list-filterBox" slot="filter">
          <base-filter
            ref="tablefilter"
            @filterCallback="_filterCallbackTeachers"
            :renderData="filterRenderDataTeachers"
            :multKeys="[]"
          />
        </div>
        <!-- =========== -->
        <!-- 每一项column -->
        <!-- =========== -->
        <edoovo-table-column
          size="L"
          label="Name"
          class="user_name"
          prop="name"
          sortName="firstName"
          :tooltip="true"
          :getTooltipText="(row) => `${row.firstName} ${row.lastName}`"
          v-slot="{ row }"
        >
          <div class="table-cell-box" @click="toStaffInfo(row)">
            <head-img
              class="table-cell-img"
              :src="row.photo ? `${row.photo}` : ``"
              :firstName="row.firstName"
              :lastName="row.lastName"
              line-height="32"
            />
            <span class="table-cell-name">{{ row.firstName }} {{ row.lastName }}</span>
          </div>
        </edoovo-table-column>
        <edoovo-table-column size="L" label="Email" prop="emailAddress" />
        <edoovo-table-column
          size="M"
          label="Phone number"
          prop="phone"
          v-slot="{ row }"
          :getTooltipText="(row) => `${row.countryCode} ${row.phoneNumber}`"
        >
          {{ row.countryCode }} {{ row.phoneNumber }}
        </edoovo-table-column>
        <edoovo-table-column size="M" label="Working title" prop="jobTitle" sortName="jobTitle" />
        <edoovo-table-column size="M" label="Type" prop="workType" sortName="workType" />
      </edoovo-table>
      <!-- Students -->
      <edoovo-table
        v-if="dataType === 'students'"
        height="100%"
        :ref="studentsData.ref"
        :data="studentsData.tableData"
        rowKey="id"
        :title="studentsData.title"
        defaultValue="-"
        class="list-tableBox"
        v-loading="studentsData.isLoading"
        @sortChange="_onSortChangeStudents"
        :sort="studentsData.sort"
      >
        <!-- ===== -->
        <!-- 空状态 -->
        <!-- ===== -->
        <div slot="empty" style="text-align: center">
          <div
            style="
              width: 213px;
              text-align: center;
              border-radius: 50%;
              margin-bottom: 12px;
              line-height: 200px;
            "
          >
            <img style="width: 100%" :src="require('@/assets/images/products/noData.svg')" />
          </div>
          <p style="font-size: 22px">No Students yet.</p>
        </div>
        <!-- ====== -->
        <!-- 筛选组件 -->
        <!-- ====== -->
        <div v-if="filterRenderDataStudents.length" class="list-filterBox" slot="filter">
          <base-filter
            ref="tablefilter"
            @filterCallback="_filterCallbackStudents"
            :renderData="filterRenderDataStudents"
            :multKeys="[]"
          />
        </div>
        <!-- =========== -->
        <!-- 每一项column -->
        <!-- =========== -->
        <edoovo-table-column
          size="L"
          label="Name"
          class="user_name"
          prop="name"
          sortName="firstName"
          :tooltip="true"
          :getTooltipText="(row) => `${row.firstName}${row.lastName}`"
          v-slot="{ row }"
        >
          <div class="table-cell-box" @click="toStudentInfo(row)">
            <head-img
              class="table-cell-img"
              :src="row.photo ? `${row.photo}` : ``"
              :firstName="row.firstName"
              :lastName="row.lastName"
              line-height="32"
            />
            <span class="table-cell-name">{{ row.firstName }} {{ row.lastName }}</span>
          </div>
        </edoovo-table-column>
        <edoovo-table-column size="S" label="Gender" prop="gender" sortName="gender" />
        <edoovo-table-column size="M" label="Age" prop="age" />
        <!-- <edoovo-table-column size="M" label="Contacts" prop="contacts" /> -->
        <edoovo-table-column
          size="M"
          label="Contacts"
          prop="contacts"
          v-slot="{ row }"
          class="table-cell-box"
        >
          <div @click="openContactsDialog(row)">
            {{ row.contacts || '-' }}
          </div>
        </edoovo-table-column>
      </edoovo-table>
    </GgPage>
    <!-- contacts number dialog -->
    <gg-dialog :visible.sync="contacts.visible" title="Contacts" :showClose="true">
      <div class="contactsDialog" v-loading="contacts.loading">
        <div class="title">Family</div>
        <edoovo-table
          height="300px"
          ref="multipleTable"
          :data="contacts.family.dataList"
          rowKey="id"
          defaultValue="-"
          class="list-tableBox"
        >
          <!-- ===== -->
          <!-- 空状态 -->
          <!-- ===== -->
          <div slot="empty" style="text-align: center">
            <div
              style="
                width: 213px;
                text-align: center;
                border-radius: 50%;
                margin-bottom: 12px;
                line-height: 200px;
              "
            >
              <img
                style="width: 100%; height: 100px"
                :src="require('@/assets/images/products/noData.svg')"
              />
            </div>
            <p style="font-size: 22px">No staff yet.</p>
          </div>
          <!-- =========== -->
          <!-- 每一项column -->
          <!-- =========== -->

          <edoovo-table-column
            size="L"
            label="Name"
            prop="name"
            :tooltip="true"
            v-slot="{ row }"
            :getTooltipText="(row) => `${row.firstName}`"
          >
            <div>
              <head-img
                class="table-cell-img"
                :src="row.photo ? `${row.photo}` : ``"
                :firstName="row.firstName"
                :lastName="row.lastName"
                line-height="32"
              />
              <span class="table-cell-name">{{ row.firstName }} {{ row.lastName }}</span>
            </div>
          </edoovo-table-column>
          <edoovo-table-column
            size="M"
            label="Relationship"
            prop="releationship"
            v-slot="{ row }"
            :getTooltipText="(row) => `${row.releationship}`"
          >
            {{ row.releationship }}
          </edoovo-table-column>
          <edoovo-table-column size="L" label="Email" prop="email" />
          <edoovo-table-column
            size="M"
            label="Phone"
            prop="phoneNumber"
            :getTooltipText="
              (row) =>
                `${row.countryCode ? row.countryCode : ''} ${
                  row.phoneNumber ? row.phoneNumber : '-'
                }`
            "
            v-slot="{ row }"
          >
            {{ row.countryCode }} {{ row.phoneNumber || '-' }}
          </edoovo-table-column>
          <edoovo-table-column
            size="M"
            label="Status"
            prop="parentStatus"
            v-slot="{ row }"
            :getTooltipText="
              (row) => `${row.parentStatus == 'Connected' ? 'Connected' : 'Pending'}`
            "
          >
            {{ row.parentStatus == 'Connected' ? 'Connected' : 'Pending' }}
          </edoovo-table-column>
        </edoovo-table>
        <div class="title" v-if="contacts.pickup.dataList.length != 0">Pickup</div>
        <edoovo-table
          max-height="300px"
          ref="multipleTable"
          :data="contacts.pickup.dataList"
          rowKey="id"
          defaultValue="-"
          class="list-tableBox"
          v-if="contacts.pickup.dataList.length != 0"
        >
          <!-- ===== -->
          <!-- 空状态 -->
          <!-- ===== -->
          <div slot="empty" style="text-align: center">
            <div
              style="
                width: 213px;
                text-align: center;
                border-radius: 50%;
                margin-bottom: 12px;
                line-height: 100px;
              "
            >
              <img
                style="width: 100%; height: 100px"
                :src="require('@/assets/images/products/noData.svg')"
              />
            </div>
            <p style="font-size: 22px">No staff yet.</p>
          </div>
          <!-- =========== -->
          <!-- 每一项column -->
          <!-- =========== -->
          <edoovo-table-column
            size="L"
            label="Name"
            prop="name"
            :tooltip="true"
            v-slot="{ row }"
            :getTooltipText="(row) => `${row.firstName}`"
            @click="() => {}"
          >
            <div>
              <head-img
                class="table-cell-img"
                :src="row.photo ? `${row.photo}` : ``"
                :firstName="row.firstName"
                :lastName="row.lastName"
                line-height="32"
              />
              <span class="table-cell-name">{{ row.firstName }} {{ row.lastName }}</span>
            </div>
          </edoovo-table-column>
          <edoovo-table-column
            size="M"
            label="Relationship"
            prop="releationship"
            v-slot="{ row }"
            :getTooltipText="(row) => `${row.releationship}`"
          >
            {{ row.releationship }}
          </edoovo-table-column>

          <edoovo-table-column size="M" label="Phone" prop="phoneNumber" v-slot="{ row }">
            {{ row.countryCode }}{{ row.phoneNumber || '-' }}
          </edoovo-table-column>
        </edoovo-table>
      </div>
    </gg-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Ajax } from '@/common'
import { buildBreadcrumb, pushState, listState } from '@/common/nav-state'
import moment from 'moment'
export default {
  name: 'people',
  components: {},
  computed: {
    ...mapState({
      user: (state) => state.user
    })
  },
  data() {
    return {
      query: {
        size: 10000,
        current: 1
      },
      menuDatas: [
        {
          name: '',
          key: 'schoolName',
          active: true,
          children: [
            {
              name: 'Teachers',
              key: 'teachers'
            },
            {
              name: 'Students',
              key: 'students'
            }
          ]
        }
      ],
      activeIndex: 'schoolName',
      dataType: 'schoolName',
      schoolName: '',
      personalInfoData: [
        { label: 'Total staff', value: '', id: 'totalStaff' },
        { label: 'Total students', value: '', id: 'totalStudent' }
      ],
      teachersData: {
        ref: 'teachersTable',
        totalNum: 0,
        title: 'Teachers',
        sort: { name: '', type: '' },
        isLoading: false,
        tableData: []
      },
      filterRenderDataTeachers: [
        { filterKey: 'firstName', type: 'input', title: 'Name' },
        { filterKey: 'emailAddress', type: 'input', title: 'Email' },
        { filterKey: 'phoneNumber', type: 'input', title: 'Phone number' },
        {
          filterKey: 'jobTitle',
          type: 'radio',
          title: 'Working title',
          radioData: []
        },
        {
          filterKey: 'workType',
          type: 'radio',
          title: 'Type',
          radioData: []
        }
      ],
      studentsData: {
        ref: 'studentsTable',
        totalNum: 0,
        title: 'Students',
        sort: { name: '', type: '' },
        isLoading: false,
        tableData: []
      },
      queryStudents: {
        size: 10000,
        current: 1
      },
      filterRenderDataStudents: [
        { filterKey: 'firstName', type: 'input', title: 'Student name' },
        {
          filterKey: 'gender',
          type: 'radio',
          title: 'Gender',
          radioData: []
        },
        { filterKey: 'dateOfBirth', type: 'date', title: 'Date of birth' },
        { filterKey: 'className', type: 'input', title: 'Class' },
        { filterKey: 'contact', type: 'input', title: 'Contacts' }
      ],
      contacts: {
        visible: false,
        loading: false,
        family: {
          isShow: false,
          dataList: [
            {
              name: 123,
              email: 'sssjjs'
            }
          ]
        },
        pickup: {
          isShow: false,
          dataList: [
            {
              name: 123,
              relationShip: 'sssjjs'
            }
          ]
        }
      }
    }
  },
  methods: {
    formDate(date) {
      let a
      if (date) {
        a = moment.utc(date).local().format('DD/MM/yyyy')
      } else {
        a = '-'
      }
      return a
    },
    computedAge(value, index) {
      // this.$nextTick(() => {
      let dateOfBirth = value
      let currentDate = new Date()
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() + 1
      let currentDay = currentDate.getDate()
      let birthYear = dateOfBirth && Number(dateOfBirth.split('/')[2])
      let birthMonth = dateOfBirth && Number(dateOfBirth.split('/')[1])
      let birthDay = dateOfBirth && Number(dateOfBirth.split('/')[0])
      let age = currentYear - birthYear
      let monthTotal = age * 12 + currentMonth - birthMonth - (currentDay < birthDay ? 1 : 0)

      if (dateOfBirth !== null) {
        this.studentsData.tableData[index].age = `${parseInt(monthTotal / 12)}y ${monthTotal % 12}m`
        // this.tableData.find((item) => item.key == "age").value =
        console.log(this.studentsData.tableData[index])
      } else {
        this.studentsData.tableData[index].age = ''
        // this.tableData.find((item) => item.key == "age").value = "";
      }
      // });
    },
    _getPickupData(id) {
      this.contacts.loading = true
      Ajax.get('/usermanage/pickup/selectByStudentId', {
        studentId: id
      })
        .then((res) => {
          this.contacts.loading = false
          this.contacts.pickup.dataList = res.data
        })
        .catch(() => {
          this.contacts.loading = false
        })
    },
    _getFamilyData(id) {
      this.contacts.loading = true
      Ajax.get('/usermanage/parent/getListByStudentId', {
        studentId: id
      })
        .then((res) => {
          this.contacts.loading = false
          this.contacts.family.dataList = res.data
        })
        .catch(() => {
          this.contacts.loading = false
        })
    },
    openContactsDialog(row) {
      this.contacts.visible = true
      this._getFamilyData(row.id)
      this._getPickupData(row.id)
    },
    menuSelect(key) {
      this._applyTabView(key)
      // tab 维度的列表状态进 URL（Ruling R7）
      this._pushList({ tab: this.activeIndex })
      this._fetchForTab()
    },
    _applyTabView(key) {
      // 只接受合法页签；URL 带入的垃圾值回退到 schoolName
      this.activeIndex = this.dataType = ['schoolName', 'teachers', 'students'].includes(key)
        ? key
        : 'schoolName'
    },
    _fetchForTab() {
      if (this.dataType === 'teachers') {
        this.getTeachers()
      } else if (this.dataType === 'students') {
        this.getStudents()
      } else {
        this.getData()
      }
    },
    // 列表 URL 状态的可比对键（tab + 双表各自命名空间的排序/筛选键，Ruling R39）：
    // teachers 表 teacherSortName/teacherFirstName/...、students 表 studentSortName/studentFirstName/...；
    // 请求体字段（query[item.filterKey]）不变，仅 URL 键加前缀，杜绝双表交叉播种
    _stateKeys() {
      return ['tab'].concat(this._tableStateKeys('teacher')).concat(this._tableStateKeys('student'))
    },
    // 单表命名空间键：排序 <prefix>SortName/<prefix>SortType + 筛选 <prefix><FilterKey>
    _tableStateKeys(prefix) {
      return [this._urlKey(prefix, 'sortName'), this._urlKey(prefix, 'sortType')].concat(
        this._tableRenderData(prefix).map((item) => this._urlKey(prefix, item.filterKey))
      )
    },
    _tableRenderData(prefix) {
      return prefix === 'teacher' ? this.filterRenderDataTeachers : this.filterRenderDataStudents
    },
    _urlKey(prefix, key) {
      return prefix + key.charAt(0).toUpperCase() + key.slice(1)
    },
    // 旧裸键（R39 前双表共用一套 URL 键）：每次 _pushList 摘除，一次性归一到前缀键
    _legacyBareKeys() {
      return ['sortName', 'sortType']
        .concat(this.filterRenderDataTeachers.map((item) => item.filterKey))
        .concat(this.filterRenderDataStudents.map((item) => item.filterKey))
    },
    // 缺失/null 键折叠为 ''，保证 push 产生的“删键”与读取侧可比
    _normalizeNavState(map) {
      const out = {}
      this._stateKeys().forEach((key) => {
        const v = map[key]
        out[key] = v === undefined || v === null ? '' : String(v)
      })
      return out
    },
    _sameNavState(a, b) {
      return this._stateKeys().every((key) => a[key] === b[key])
    },
    // 自身导航统一入口：push 后记录本页最近一次 URL 状态，供 $route 监听识别自身导航
    _pushList(patch) {
      // Ruling R40：提升（promote）——_navState 里已归一的前缀键（含旧裸键映射值）作为默认并入，
      // patch 显式值优先，随本次 push 落地（值保留、键归一）；旧裸键随每次 push 摘除（Ruling R39）
      const full = Object.assign({}, this._navState, patch)
      this._legacyBareKeys().forEach((key) => {
        if (full[key] === undefined) {
          full[key] = ''
        }
      })
      // 记录状态取 push 落地 query 的投影：URL 与 _navState 同一口径（R2 数组解包/对象丢弃）
      const query = listState.push(this.$router, this.$route, full)
      this._navState = this._normalizeNavState(query)
    },
    // 以 URL 状态重建列表内存状态（created 与前进/后退复用共用）
    _seedFromQuery(state) {
      this._applyTabView(state.tab || 'schoolName')
      this.query = { size: 10000, current: 1 }
      this.queryStudents = { size: 10000, current: 1 }
      // 旧裸键只映射到当前页签的命名空间一次并提升（Ruling R39/R40）；URL 已有前缀键时以前缀键为准，
      // 映射值进 _navState 随下一次 _pushList 落地为前缀键（值保留、键归一），裸键仍由 _pushList 摘除
      const src = Object.assign({}, this._legacyStateForActiveTab(), state)
      this._navState = this._normalizeNavState(src)
      // 控件回显：排序与筛选项按 URL 中的状态显示（重建数组，供 BaseFilter 播种）
      const rehydrate = (table, renderData, query, prefix) => {
        table.sort = {
          name: src[this._urlKey(prefix, 'sortName')] || '',
          type: src[this._urlKey(prefix, 'sortType')] || ''
        }
        if (table.sort.name) {
          query.sortName = table.sort.name
          query.sortType = table.sort.type
        }
        return renderData.map((item) => {
          const val = src[this._urlKey(prefix, item.filterKey)]
          const seed = { filterVal: '', showVal: '' }
          if (val !== undefined && val !== null && val !== '') {
            query[item.filterKey] = val
            seed.filterVal = val
            if (item.type === 'date') {
              seed.showVal = moment(val).format('DD/MM/YYYY')
            } else if (item.type === 'radio' && item.radioData) {
              const matched = item.radioData.find((radio) => radio.value === val)
              seed.showVal = matched ? matched.key : val
            } else {
              seed.showVal = val
            }
          }
          return Object.assign({}, item, seed)
        })
      }
      this.filterRenderDataTeachers = rehydrate(
        this.teachersData,
        this.filterRenderDataTeachers,
        this.query,
        'teacher'
      )
      this.filterRenderDataStudents = rehydrate(
        this.studentsData,
        this.filterRenderDataStudents,
        this.queryStudents,
        'student'
      )
    },
    // 旧裸键 → 当前页签命名空间（仅 teachers/students 页签有表；schoolName 页签无表可播，不回填）
    _legacyStateForActiveTab() {
      const prefix =
        this.activeIndex === 'teachers'
          ? 'teacher'
          : this.activeIndex === 'students'
            ? 'student'
            : ''
      if (!prefix) {
        return {}
      }
      const fields = ['sortName', 'sortType'].concat(
        this._tableRenderData(prefix).map((item) => item.filterKey)
      )
      const bare = listState.read(this.$route, fields)
      const out = {}
      fields.forEach((key) => {
        if (bare[key] !== undefined) {
          out[this._urlKey(prefix, key)] = bare[key]
        }
      })
      return out
    },
    getData() {
      this.menuDatas.forEach((item) => {
        item.name = this.schoolName
      })

      Ajax.get('/usermanage/location/selectTotalByLocationId', {
        locationId: this.user.locationId
      }).then((res) => {
        if (res.code === '0000') {
          this.personalInfoData.forEach((item) => {
            item.value = res.data[item.id]
          })
        }
      })
    },
    getTeachers() {
      this.teachersData.isLoading = true
      let params = Object.assign({}, this.query, {
        userId: this.user.userId,
        locationId: this.user.locationId
      })
      Ajax.post('/usermanage/staff/pageList', params)
        .then((res) => {
          if (res.code === '0000') {
            this.teachersData.isLoading = false
            let { records, total } = res.data
            this.teachersData.tableData = records
            this.teachersData.totalNum = total
          }
        })
        .catch((err) => {
          this.teachersData.isLoading = false
        })
    },
    _onSortChangeTeachers(sort) {
      this.teachersData.sort = sort
      this.query.sortName = sort.name
      this.query.sortType = sort.type
      this._pushList({
        teacherSortName: sort.name,
        teacherSortType: sort.type
      })
      this.getTeachers()
    },
    _filterCallbackTeachers(data) {
      let obj = {}
      if (data.length == 0) {
        this.query = {
          size: 10000,
          current: 1
        }
      }

      data.filter((i) => {
        obj[i.filterKey] = i.filterVal
      })

      this.query = {
        size: 10000,
        current: 1
      }
      this.query = Object.assign(obj, this.query)
      // URL 与重建后的 query 同步：空值会从 URL 中删除（含被丢弃的旧筛选/排序）
      const patch = {
        teacherSortName: '',
        teacherSortType: ''
      }
      this.filterRenderDataTeachers.forEach((item) => {
        patch[this._urlKey('teacher', item.filterKey)] = obj[item.filterKey] || ''
      })
      this._pushList(patch)
      this.getTeachers()
    },
    toStaffInfo(row) {
      console.log(row)
      // 导航参数进 URL（详情侧按 ?id/type 读取，Ruling R1/R10），不再写 staffInfo；
      // type "0" 为 People 只读口径（pageType==='1' 才放开编辑），people 为面包屑上下文
      this.$store.commit(
        'SET_BREADCRUMDATA',
        buildBreadcrumb(this.$route, {
          segments: [
            { routeName: 'locations', from: 'schoolName' },
            { routeName: 'people', name: 'People' },
            { from: 'personName' }
          ],
          schoolName: this.schoolName,
          personName: `${row.firstName} ${row.lastName}`
        })
      )
      pushState(this.$router, {
        name: 'staffPersonalInfo',
        query: { id: row.userId, type: '0', people: 'true' }
      })
    },
    toStudentInfo(row) {
      this.$store.commit('SET_LOCATIONID', row.schoolId)
      this.$store.commit(
        'SET_BREADCRUMDATA',
        buildBreadcrumb(this.$route, {
          segments: [
            { routeName: 'locations', from: 'schoolName' },
            { routeName: 'people', name: 'People' },
            { from: 'personName' }
          ],
          schoolName: this.schoolName,
          personName: `${row.firstName} ${row.lastName}`
        })
      )
      // 导航参数进 URL（Ruling R1/R10）：必填 id/type + 逐键可选标签，不再写 studentInfo
      pushState(this.$router, {
        name: 'peopleStudentsPersonalInfo',
        query: {
          id: row.id,
          type: '0',
          className: row.className || '',
          locationName: row.locationName || '',
          status: row.status || '',
          people: true,
          name: this.schoolName
        }
      })
    },
    getStudents() {
      this.studentsData.isLoading = true
      let params = Object.assign({}, this.queryStudents, {
        userId: this.user.userId,
        locationId: this.user.locationId
      })
      Ajax.post('/usermanage/student/stuPageList', params)
        .then((res) => {
          if (res.code === '0000') {
            this.studentsData.isLoading = false
            let { records, total } = res.data
            this.studentsData.tableData = records
            this.studentsData.tableData.forEach((item, index) => {
              let a = this.formDate(item.dateOfBirth)
              console.log(a)
              if (a == '-') {
                a = null
              }

              this.computedAge(a, index)
            })
            this.studentsData.totalNum = total
          }
        })
        .catch((err) => {
          this.studentsData.isLoading = false
        })
    },
    _onSortChangeStudents(sort) {
      this.studentsData.sort = sort
      this.queryStudents.sortName = sort.name
      this.queryStudents.sortType = sort.type
      this._pushList({
        studentSortName: sort.name,
        studentSortType: sort.type
      })
      this.getStudents()
    },
    _filterCallbackStudents(data) {
      let obj = {}
      if (data.length == 0) {
        this.queryStudents = {
          size: 10000,
          current: 1
        }
      }

      data.filter((i) => {
        obj[i.filterKey] = i.filterVal
      })

      this.queryStudents = {
        size: 10000,
        current: 1
      }
      this.queryStudents = Object.assign(obj, this.queryStudents)
      // URL 与重建后的 query 同步：空值会从 URL 中删除（含被丢弃的旧筛选/排序）
      const patch = {
        studentSortName: '',
        studentSortType: ''
      }
      this.filterRenderDataStudents.forEach((item) => {
        patch[this._urlKey('student', item.filterKey)] = obj[item.filterKey] || ''
      })
      this._pushList(patch)
      this.getStudents()
    },
    getSettingList(dataLevel, dataType) {
      let params = {
        dataLevel: dataLevel,
        dataType: dataType,
        userId: this.user.userId
      }

      Ajax.post('/usermanage/setting/getList', params)
        .then((res) => {
          let arr = []
          res.data.forEach((item1) => {
            this.filterRenderDataTeachers.forEach((item) => {
              let obj = {}
              if (item1.dataType === item.filterKey) {
                obj = {
                  key: item1.value,
                  value: item1.value
                }
                arr.push(obj)
              }
            })
            this.filterRenderDataStudents.forEach((item) => {
              let obj = {}
              if (item1.dataType === item.filterKey) {
                obj = {
                  key: item1.value,
                  value: item1.value
                }
                arr.push(obj)
              }
            })
          })

          if (dataLevel === 'staff') {
            this.filterRenderDataTeachers.find((item) => item.filterKey === dataType).radioData =
              arr
          } else {
            this.filterRenderDataStudents.forEach((item) => {
              if (item.filterKey === dataType) {
                item.radioData = arr
              }
            })
          }
        })
        .catch((err) => {
          console.log(err, 11)
        })
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        // 浏览器前进/后退复用组件：URL 与本页最近导航不一致时按 URL 重新播种并重查
        const state = listState.read(this.$route, this._stateKeys(), {
          tab: 'schoolName'
        })
        // 比较口径与播种同式：裸键先提升再比（Ruling R40），裸键 URL 不因键名差异误判外部导航；
        // _navState 记账在 _seedFromQuery 内完成
        const navState = this._normalizeNavState(
          Object.assign({}, this._legacyStateForActiveTab(), state)
        )
        if (this._sameNavState(navState, this._navState)) return
        this._seedFromQuery(state)
        this._fetchForTab()
      }
    }
  },
  created() {
    this.schoolName = this.user.schoolName
    // 列表状态以 URL 为准；缺失的默认键只回填一次（router.replace）
    const state = listState.defaultsFrom(this.$router, this.$route, {
      tab: 'schoolName'
    })
    // _navState 记账在 _seedFromQuery 内完成（含 R40 提升值）
    this._seedFromQuery(state)
    this._fetchForTab()
    this.getSettingList('staff', 'workType')
    this.getSettingList('staff', 'jobTitle')
    this.getSettingList('student', 'gender')
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let schoolName = vm.user.schoolName
      vm.schoolName = schoolName
    })
  }
}
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.form-dialog .content {
  min-height: 500px !important;
}
.contactsDialog {
  .title {
    margin-bottom: 20px;
    font-family: 'Roboto-medium';
    font-size: 14px;
    color: #202124;
  }

  .list-tableBox {
    margin-bottom: 20px;
    max-height: 200px;
  }
}
</style>
